<gc-dialog-event-confirm-overlay [overlay]="Overlay.Hide"
                                 (confirmed)="close(true)"
                                 (cancelled)="close()"></gc-dialog-event-confirm-overlay>
